import { api } from "../api";
import { EMPTY_GUID, TEMP_GUID, asArray } from '../../utils/fermer-enregistrement-capture.js';
import { resolveEspeceDescription } from '../../utils/fermer-enregistrement-peche-capture.js';
import { resolveGibierDescription } from '../../utils/fermer-enregistrement-chasse-capture.js';

export async function rechercherEnregistrement(email, noEnregistrement) {
    // return api.get(``)
    return null
}

export async function getEnregistrementList(idClient) {
    return api.get(`Enregistrement/FermetureEnregistrement/${idClient}`)
}

export async function getEnregistrement(idEnregistrementEntete) {
  return api.get(`Enregistrement/${idEnregistrementEntete}/Enregistrement`);
}

export async function getActivites() {
  const activites = await api.get('Activite/');
  if (!activites || !Array.isArray(activites)) {
    return [];
  }
  return activites
    .filter(a => a.actif && a.disponibleEnLigne)
    .sort((a, b) => a.description.toUpperCase().localeCompare(b.description.toUpperCase(), 'en'));
}

export async function getCaptures(idEnregistrementEntete) {
  return api.get(`Enregistrement/${idEnregistrementEntete}/Captures`);
}

export async function getPointsEaux(idActivite) {
  const pointsEaux = await api.get(`Activite/${idActivite}/PointEau/`);
  if (!pointsEaux || !Array.isArray(pointsEaux)) {
    return [];
  }
  return pointsEaux
    .filter(pe => pe.idPointEau !== EMPTY_GUID && pe.idPointEau !== TEMP_GUID && pe.disponibleEnLigne && pe.actif)
    .sort((a, b) => a.description.toUpperCase().localeCompare(b.description.toUpperCase(), 'en'));
}

export async function getEspecesPointEau(idPointEau) {
  const pointEauEspeces = asArray(await api.get(`PointEau/${idPointEau}/EspecePointEau`));

  return pointEauEspeces.map(pe => {
    const idEspece = pe.idEspece || pe.IdEspece || pe.id || pe.Id;
    return {
      ...pe,
      idEspece,
      description: resolveEspeceDescription(pe),
    };
  });
}

export async function getSecteurs(idActivite) {
  const secteurs = await api.get(`Activite/${idActivite}/Secteur/`);
  if (!secteurs || !Array.isArray(secteurs)) {
    return [];
  }
  return secteurs
    .filter(s => s.idSecteur !== EMPTY_GUID && s.idSecteur !== TEMP_GUID && s.actif !== false)
    .sort((a, b) => (a.nomSecteur || a.NomSecteur || '').toUpperCase().localeCompare((b.nomSecteur || b.NomSecteur || '').toUpperCase(), 'en'));
}

export async function getGibiers(idActivite) {
  const gibiers = await api.get(`Activite/${idActivite}/Gibier/`);
  if (!gibiers || !Array.isArray(gibiers)) {
    return [];
  }
  return gibiers
    .filter(g => g.idGibier !== EMPTY_GUID && g.idGibier !== TEMP_GUID && g.actif !== false)
    .sort((a, b) => resolveGibierDescription(a).toUpperCase().localeCompare(resolveGibierDescription(b).toUpperCase(), 'en'));
}

export async function postFemerEnregistrement(data) {
  return api.post('Enregistrement/FermerEnregistrement', JSON.stringify(data), false);
}
